import React from "react";
import { useNavigate } from "react-router-dom";
import useIsChildBranch from "../../hooks/useIsChildBranch";
import useSubscriptionRestricted from "../../hooks/useSubscriptionRestricted";
import { BILLING_PATH, getSubscriptionNoticeMessage } from "../../utils/subscriptionAccess";
import "./subscriptionNoticeBar.scss";

function SubscriptionNoticeBar() {
  const navigate = useNavigate();
  const isChildBranch = useIsChildBranch();
  const { subscriptionAccess, showExpiryNotice } = useSubscriptionRestricted();

  if (!showExpiryNotice) return null;

  if (isChildBranch) {
    return (
      <div
        className="subscription-notice-bar subscription-notice-bar--branch"
        role="alert"
      >
        <i className="fa fa-info-circle me-2" aria-hidden="true" />
        <span>
          Subscription billing is managed on the main company account. Contact your head office to renew.
        </span>
      </div>
    );
  }

  const severity = subscriptionAccess.noticeSeverity || "warning";
  const message = getSubscriptionNoticeMessage(subscriptionAccess);

  const handleClick = () => {
    navigate(BILLING_PATH);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      className={`subscription-notice-bar subscription-notice-bar--${severity}`}
      role="alert"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      title="Go to Billing"
    >
      <i className="fa fa-exclamation-circle me-2 flex-shrink-0" aria-hidden="true" />
      <span className="subscription-notice-bar__text">{message}</span>
      <span className="subscription-notice-bar__action ms-2 flex-shrink-0">
        Pay invoice <i className="fa fa-chevron-right ms-1" aria-hidden="true" />
      </span>
    </div>
  );
}

export default SubscriptionNoticeBar;
